// The six package category folders under `packages/` in Storyblok, slug → label.
// The server list APIs validate `?category=` against these slugs; the app uses the
// labels for breadcrumbs, category tags and overview filters. Adding a category
// means creating the Storyblok folder AND adding it here.
export const PACKAGE_CATEGORIES = {
    'romantic': 'Romantic',
    'family': 'Family',
    'beach-and-safari': 'Beach & Safari',
    'short-escapes': 'Short Escapes',
    'group-and-budget': 'Group & Budget',
    'kilimanjaro-climb': 'Kilimanjaro Climb',
}
